import { useEffect } from "react"

export type SourceMetricIdsChangeHandler = (metricIds: string[] | null) => void

interface UseSourceDisplayedMetricIdsParams {
  metricIds: string[] | null | undefined
  flattenedMetrics?: Record<string, unknown> | null
  onMetricsChange?: SourceMetricIdsChangeHandler
}

export function useSourceDisplayedMetricIds({
  metricIds,
  flattenedMetrics,
  onMetricsChange,
}: UseSourceDisplayedMetricIdsParams) {
  useEffect(() => {
    if (!onMetricsChange || !flattenedMetrics) {
      return
    }

    onMetricsChange(metricIds?.length ? metricIds : null)
    return () => onMetricsChange(null)
  }, [metricIds, flattenedMetrics, onMetricsChange])
}
